import { Observable } from "rxjs";
import { RequestService, TissueCollectionType } from "../../shared/services/request.service";
import { asEnumerable } from "linq-es2015";
import { CeSiteService } from "../../shared/services/ce-site.service";
import { CropService } from "../../shared/services/crop.service";
import { RequestPurposeService } from "../../shared/services/request-purpose.service";
import { ProductConceptService } from "../../shared/services/product-concept.service";
import { SubstrateService } from "../../shared/services/substrate.service";
import { IrrigationMethodService } from "../../shared/services/irrigation-method.service";
import { FertigationMethodService } from "../../shared/services/fertigation-method.service";
import { LightingInstructionService } from "../../shared/services/lighting-instruction.service";
import { TemperatureInstructionService } from "../../shared/services/temperature-instruction.service";
import { HumidityInstructionService } from "../../shared/services/humidity-instruction.service";
import { PesticideInstructionService } from "../../shared/services/pesticide-instruction.service";
import { PollinationCategoryService } from "../../shared/services/pollination-category.service";
import { ContainerDefinitionService } from "../../shared/services/container-definition.service";
import { PmoProgramService } from "../../shared/services/pmo-program.service";
import { UserService } from "../../shared/services/user.service";
import { PollinationTypeService } from "../../shared/services/pollination-type.service";
import { LaboratoryService } from "../../shared/services/laboratory.service";
import { TissueTypeService } from "../../shared/services/tissue-type.service";
import { GrowthStageService } from "../../shared/services/growth-stage.service";
import { ConjunctionEnum } from "../../shared/models/conjunction.enum";
import { PollinationStakeLabelService } from "../../shared/services/pollination-stake-label.service";
import { SprayBoothStudyService } from "../../shared/services/spray-booth-study.service";
var RequestReviewResolver = /** @class */ (function () {
    function RequestReviewResolver(requestService, userService, ceSiteService, cropService, requestPurposeService, pmoProgramService, productConceptService, substrateService, irrigationMethodService, fertigationMethodService, lightingInstructionService, temperatureInstructionService, humidityInstructionService, pesticideInstructionService, pollinationCategoryService, containerDefinitionService, pollinationTypeService, labService, growthStageService, tissueTypeService, stakeLabelService, sprayStudyService) {
        this.requestService = requestService;
        this.userService = userService;
        this.ceSiteService = ceSiteService;
        this.cropService = cropService;
        this.requestPurposeService = requestPurposeService;
        this.pmoProgramService = pmoProgramService;
        this.productConceptService = productConceptService;
        this.substrateService = substrateService;
        this.irrigationMethodService = irrigationMethodService;
        this.fertigationMethodService = fertigationMethodService;
        this.lightingInstructionService = lightingInstructionService;
        this.temperatureInstructionService = temperatureInstructionService;
        this.humidityInstructionService = humidityInstructionService;
        this.pesticideInstructionService = pesticideInstructionService;
        this.pollinationCategoryService = pollinationCategoryService;
        this.containerDefinitionService = containerDefinitionService;
        this.pollinationTypeService = pollinationTypeService;
        this.labService = labService;
        this.growthStageService = growthStageService;
        this.tissueTypeService = tissueTypeService;
        this.stakeLabelService = stakeLabelService;
        this.sprayStudyService = sprayStudyService;
        this.pmoProject = null;
    }
    RequestReviewResolver.prototype.resolve = function (route) {
        var _this = this;
        this.id = route.params["id"];
        return Observable.forkJoin(this.requestService.getRequestInformation(this.id), this.requestService.getDetails(this.id), this.requestService.getDesign(this.id), this.userService.getAll(), this.ceSiteService.getAll(), this.cropService.getAll(), this.requestPurposeService.getAll(), this.pmoProgramService.getAllPrograms(), this.productConceptService.getAll(), this.substrateService.getAll(), this.irrigationMethodService.getAll(), this.fertigationMethodService.getAll(), this.lightingInstructionService.getAll(), this.temperatureInstructionService.getAll(), this.humidityInstructionService.getAll(), this.pesticideInstructionService.getAll(), this.pollinationCategoryService.getAll(), this.containerDefinitionService.getFlats(), this.containerDefinitionService.getPots(), this.pollinationTypeService.getAll(), this.labService.getAll(), this.growthStageService.getAll(), this.tissueTypeService.getAll(), this.sprayStudyService.getAllActives(), this.sprayStudyService.getAllAdjuvantUnits(), this.sprayStudyService.getAllAdjuvants(), this.sprayStudyService.getAllTimepoints(), this.sprayStudyService.getAllVolumes(), this.sprayStudyService.getAllRateUnits()).switchMap(function (_a) {
            var requestInformation = _a[0], details = _a[1], design = _a[2], users = _a[3], cesites = _a[4], crops = _a[5], requestpurposes = _a[6], pmoPrograms = _a[7], productconcepts = _a[8], substrates = _a[9], irrigationMethods = _a[10], fertigationMethods = _a[11], lightingInstructions = _a[12], temperatureInstructions = _a[13], humidityInstructions = _a[14], pesticideInstructions = _a[15], pollinationCategories = _a[16], flatTypes = _a[17], potTypes = _a[18], pollinationTypes = _a[19], labs = _a[20], growthStages = _a[21], tissueTypes = _a[22], actives = _a[23], adjuvantUnits = _a[24], adjuvants = _a[25], applicationTimepoints = _a[26], applicationVolumes = _a[27], rateUnits = _a[28];
            _this.details = details || {};
            _this.design = design || {};
            _this.requestInformation = requestInformation || {};
            _this.config = {
                users: asEnumerable(users),
                ceSites: asEnumerable(cesites),
                crops: asEnumerable(crops),
                requestPurposes: asEnumerable(requestpurposes),
                pmoPrograms: asEnumerable(pmoPrograms),
                productConcepts: asEnumerable(productconcepts),
                substrates: asEnumerable(substrates),
                irrigationMethods: asEnumerable(irrigationMethods),
                fertigationMethods: asEnumerable(fertigationMethods),
                lightingInstructions: asEnumerable(lightingInstructions),
                temperatureInstructions: asEnumerable(temperatureInstructions),
                humidityInstructions: asEnumerable(humidityInstructions),
                pesticideInstructions: asEnumerable(pesticideInstructions),
                pollinationCategories: asEnumerable(pollinationCategories),
                flatTypes: asEnumerable(flatTypes),
                potTypes: asEnumerable(potTypes),
                pollinationTypes: asEnumerable(pollinationTypes),
                growthStages: asEnumerable(growthStages),
                laboratories: asEnumerable(labs),
                tissueTypes: asEnumerable(tissueTypes),
                actives: asEnumerable(actives),
                adjuvantUnits: asEnumerable(adjuvantUnits),
                adjuvants: asEnumerable(adjuvants),
                applicationTimepoints: asEnumerable(applicationTimepoints),
                applicationVolumes: asEnumerable(applicationVolumes),
                rateUnits: asEnumerable(rateUnits)
            };
            return Observable.zip(_this.details.projectKey ? _this.pmoProgramService.getProjects({ pmoProgramKey: _this.details.programKey }) : Observable.of(null));
        }).map(function (_a) {
            var pmoprojects = _a[0];
            var projects = asEnumerable(pmoprojects);
            _this.pmoProject = _this.details.projectKey ? projects.Single(function (p) { return p.projectKey === _this.details.projectKey; }).pmoProjectName : null;
            _this.formatRequest();
            return _this.request;
        });
    };
    RequestReviewResolver.prototype.formatRequest = function () {
        var _this = this;
        var requestedSeed = null;
        if (this.design.requestedSeed && this.design.requestedSeed.length > 0) {
            requestedSeed = asEnumerable(this.design.requestedSeed)
                .Select(function (s) { return ({
                entryNumber: s.entryNumber,
                siid: s.siid,
                geid: s.geid,
                geName: s.geName,
                numberOfSeeds: s.numberOfSeeds,
                regulatoryStatus: s.regulatoryStatus,
                containsColorMarker: s.containsColorMarker,
                treatments: asEnumerable(s.treatments)
                    .Select(function (t) { return ({
                    treatmentNumber: t.treatmentNumber,
                    seedCount: t.seedCount
                }); }).ToArray()
            }); }).ToArray();
        }
        var pollinationInstructions = null;
        if (this.design.pollinationInstructions) {
            var hasCategory_1 = this.design.pollinationInstructions.pollinationCategoryId != null;
            var items = asEnumerable(this.design.pollinationInstructions.preferences)
                .SelectMany(function (g, groupIndex) {
                return asEnumerable(g.items)
                    .Select(function (i, itemIndex) { return ({
                    groupIndex: groupIndex,
                    groupConjunction: _this.stakeLabelService.getGroupConjunction(groupIndex, g.conjunction, hasCategory_1),
                    itemIndex: itemIndex,
                    itemConjunction: itemIndex === 0 ? "" : (i.conjunction === ConjunctionEnum.And ? "&" : "/"),
                    pollinationType: i.pollinationTypeId,
                    geName: i.geName,
                    truncatedPollinationType: ""
                }); });
            })
                .ToArray();
            var pollinationCategoryName = this.design.pollinationInstructions.pollinationCategoryId ?
                this.config.pollinationCategories.Single(function (c) { return c.id === _this.design.pollinationInstructions.pollinationCategoryId; }).name :
                null;
            pollinationInstructions = {
                preferences: asEnumerable(this.design.pollinationInstructions.preferences)
                    .OrderBy(function (g) { return g.orderNumber; })
                    .Select(function (g, index) { return ({
                    order: g.orderNumber,
                    conjunction: g.conjunction === ConjunctionEnum.Unknown ? '' : ConjunctionEnum[g.conjunction],
                    items: asEnumerable(g.items)
                        .Select(function (item) { return ({
                        order: item.orderNumber,
                        conjunction: item.conjunction === ConjunctionEnum.Unknown ? '' : ConjunctionEnum[item.conjunction],
                        pollinationType: _this.config.pollinationTypes.Single(function (t) { return t.id === item.pollinationTypeId; }).name,
                        geName: item.geName
                    }); })
                        .ToArray()
                }); })
                    .ToArray(),
                pollinationCategory: pollinationCategoryName,
                stakeLabelString: this.stakeLabelService.createStakeLabel(items, this.design.pollinationInstructions.pollinationCategoryId, pollinationCategoryName),
                donorsNeeded: this.design.pollinationInstructions.donorsNeeded
            };
        }
        var samplings = null;
        if (this.design.requestedSamplings) {
            samplings = [];
            this.design.requestedSamplings.forEach(function (s) {
                var laboratory = s.laboratoryId ? _this.config.laboratories.SingleOrDefault(function (l) { return l.id === s.laboratoryId; }) : null;
                var labName = laboratory ? laboratory.name : null;
                var assay = s.laboratoryAssayId ? asEnumerable(laboratory.assays).Single(function (l) { return l.id === s.laboratoryAssayId; }).name : null;
                var tissueType = s.tissueTypeId ? _this.config.tissueTypes.SingleOrDefault(function (l) { return l.id === s.tissueTypeId; }).name : null;
                var tissueCollectionType = TissueCollectionType[s.tissueCollectionType];
                var growthStage = s.growthStageId !== null ? _this.config.growthStages.SingleOrDefault(function (l) { return l.id === s.growthStageId; }).name : null;
                samplings.push({
                    assay: assay,
                    laboratory: labName,
                    tissueType: tissueType,
                    tissueCollectionType: tissueCollectionType,
                    growthStage: growthStage,
                    daysAfterPlanting: s.daysAfterPlanting,
                    order: s.order
                });
            });
        }
        var treatments = null;
        if (this.design.treatments && this.design.treatments.length > 0) {
            var sprayBoothStudies_1 = null;
            treatments = [];
            this.design.treatments.forEach(function (t) {
                var plantingInstructions = {
                    treatmentNumber: t.treatmentNumber,
                    seedsToStart: t.plantingInstructions.seedsToStart,
                    plantsToPots: t.plantingInstructions.plantsToPots,
                    plantsToHarvest: t.plantingInstructions.plantsToHarvest
                };
                var flatInstructions = {
                    treatmentNumber: t.treatmentNumber,
                    directSeedToPots: t.flatInstructions.directSeedToPots,
                    flatType: t.flatInstructions.flatTypeId ? _this.config.flatTypes.Single(function (c) { return c.id === t.flatInstructions.flatTypeId; }).name : null,
                    substrate: t.flatInstructions.substrateId ? _this.config.substrates.Single(function (s) { return s.id === t.flatInstructions.substrateId; }).name : null,
                    irrigationMethod: t.flatInstructions.irrigationMethodId ? _this.config.irrigationMethods.Single(function (m) { return m.id === t.flatInstructions.irrigationMethodId; }).name : null,
                    fertigationMethod: t.flatInstructions.fertigationMethodId ? _this.config.fertigationMethods.Single(function (m) { return m.id === t.flatInstructions.fertigationMethodId; }).name : null
                };
                var pottingInstructions = {
                    treatmentNumber: t.treatmentNumber,
                    potType: t.pottingInstructions && t.pottingInstructions.potTypeId ? _this.config.potTypes.Single(function (c) { return c.id === t.pottingInstructions.potTypeId; }).name : null,
                    substrate: t.pottingInstructions && t.pottingInstructions.substrateId ? _this.config.substrates.Single(function (s) { return s.id === t.pottingInstructions.substrateId; }).name : null,
                    irrigationMethod: t.pottingInstructions && t.pottingInstructions.irrigationMethodId ? _this.config.irrigationMethods.Single(function (m) { return m.id === t.pottingInstructions.irrigationMethodId; }).name : null,
                    fertigationMethod: t.pottingInstructions && t.pottingInstructions.fertigationMethodId ? _this.config.fertigationMethods.Single(function (m) { return m.id === t.pottingInstructions.fertigationMethodId; }).name : null
                };
                var plantHandlingInstructions = {
                    treatmentNumber: t.treatmentNumber,
                    lightingInstruction: t.plantHandlingInstructions.lightingInstructionId ? _this.config.lightingInstructions.Single(function (i) { return i.id === t.plantHandlingInstructions.lightingInstructionId; }).name : null,
                    temperatureInstruction: t.plantHandlingInstructions.temperatureInstructionId ? _this.config.temperatureInstructions.Single(function (i) { return i.id === t.plantHandlingInstructions.temperatureInstructionId; }).name : null,
                    humidityInstruction: t.plantHandlingInstructions.humidityInstructionId ? _this.config.humidityInstructions.Single(function (i) { return i.id === t.plantHandlingInstructions.humidityInstructionId; }).name : null,
                    imagingNeeded: t.plantHandlingInstructions.imagingNeeded,
                };
                if (t.sprayBoothStudy && Array.isArray(t.sprayBoothStudy)) {
                    sprayBoothStudies_1 = [];
                    sprayBoothStudies_1 = t.sprayBoothStudy.map(function (s) { return ({
                        actives: s.actives.map(function (active) {
                            var herbicideTradeName = active.activeId
                                ? _this.config.actives.Single(function (i) { return i.id === active.activeId; })
                                    .herbicideTradeName
                                : null;
                            var factsid = active.activeId
                                ? _this.config.actives.Single(function (i) { return i.id === active.activeId; })
                                    .factsid
                                : null;
                            var activeIngredient = active.activeId
                                ? _this.config.actives.Single(function (i) { return i.id === active.activeId; })
                                    .activeIngredient
                                : null;
                            var concentrationValue = active.activeId
                                ? _this.config.actives.Single(function (i) { return i.id === active.activeId; })
                                    .concentrationValue
                                : null;
                            var concentrationUnit = active.activeId
                                ? _this.config.actives.Single(function (i) { return i.id === active.activeId; })
                                    .concentrationUnit
                                : null;
                            var rateValue = active.rateValue;
                            var rateUnit = active.rateUnitId
                                ? _this.config.rateUnits.Single(function (i) { return i.id === active.rateUnitId; }).unit
                                : null;
                            var relativeFieldRate = active.relativeFieldRate;
                            return {
                                herbicideTradeName: herbicideTradeName,
                                factsid: factsid,
                                activeIngredient: activeIngredient,
                                concentrationValue: concentrationValue,
                                concentrationUnit: concentrationUnit,
                                rateValue: rateValue,
                                rateUnit: rateUnit,
                                relativeFieldRate: relativeFieldRate,
                            };
                        }),
                        adjuvants: s.adjuvants.map(function (adjuvant) {
                            var adjuvantName = adjuvant.adjuvantId
                                ? _this.config.adjuvants.Single(function (i) { return i.id === adjuvant.adjuvantId; }).name
                                : null;
                            var adjuvantValue = adjuvant.adjuvantValue;
                            var adjuvantDef = adjuvant.adjuvantId
                                ? _this.config.adjuvants.Single(function (i) { return i.id === adjuvant.adjuvantId; })
                                : null;
                            var adjuvantUnit = adjuvantDef
                                ? _this.config.adjuvantUnits.Single(function (u) { return u.id === adjuvantDef.adjuvantUnitId; }).unit || null
                                : null;
                            return {
                                adjuvantName: adjuvantName,
                                adjuvantValue: adjuvantValue,
                                adjuvantUnit: adjuvantUnit,
                            };
                        }),
                        treatmentNumber: t.treatmentNumber,
                        sprayEventNumber: s.sprayEventNumber,
                        applicationVolume: s.applicationVolumeId
                            ? _this.config.applicationVolumes.Single(function (i) { return i.id === s.applicationVolumeId; }).volume
                            : null,
                        applicationTimepoint: s.applicationTimepointId
                            ? _this.config.applicationTimepoints.Single(function (i) { return i.id === s.applicationTimepointId; }).timepoint
                            : null,
                        sprayEventDaysAfterPlanting: s.sprayEventDaysAfterPlanting,
                    }); });
                }
                treatments.push({
                    treatmentNumber: t.treatmentNumber,
                    plantingInstructions: plantingInstructions,
                    pottingInstructions: pottingInstructions,
                    flatInstructions: flatInstructions,
                    plantHandlingInstructions: plantHandlingInstructions,
                    sprayBoothStudyInstructions: sprayBoothStudies_1
                });
            });
        }
        var requester = this.config.users.Single(function (u) { return u.id === _this.details.requesterId; });
        var requestDelegate = this.details.delegateId ? this.config.users.Single(function (u) { return u.id === _this.details.delegateId; }) : null;
        this.request = {
            id: this.id,
            requestNumber: this.requestInformation.requestNumber,
            requester: requester.givenName + " " + requester.surname,
            delegate: requestDelegate ? requestDelegate.givenName + " " + requestDelegate.surname : "",
            title: this.details.title,
            description: this.details.description,
            regulatoryStatus: this.details.regulatoryStatus,
            ppqRequired: this.details.ppqRequired,
            phytoInspectionRequired: this.details.phytoInspectionRequired,
            ceSite: this.details.ceSiteId ? this.config.ceSites.Single(function (s) { return s.id === _this.details.ceSiteId; }).name : null,
            crop: this.details.cropId ? this.config.crops.Single(function (s) { return s.id === _this.details.cropId; }).name : null,
            cropId: this.details.cropId,
            requestPurpose: this.details.requestPurposeId ? this.config.requestPurposes.Single(function (s) { return s.id === _this.details.requestPurposeId; }).name : null,
            pmoProgram: this.details.programKey ? this.config.pmoPrograms.Single(function (p) { return p.programKey === _this.details.programKey; }).pmoProgramName : null,
            pmoProject: this.pmoProject,
            productConcepts: this.config.productConcepts.Join(this.details.productConceptIds, function (productConcept) { return productConcept.id; }, function (id) { return id; }, function (productConcept) { return ({ name: productConcept.name }); })
                .Select(function (c) { return c.name; })
                .ToArray()
                .join(", "),
            requestedPlantingDate: this.details.requestedPlantingDate,
            requestedSeedPacketDate: this.details.requestedSeedPacketDate,
            weeksOfColdTreatment: this.details.weeksOfColdTreatment,
            numberOfTreatments: treatments ? treatments.length : null,
            numberOfReps: this.design.numberOfReps,
            numberOfSeedsPerCell: this.design.numberOfSeedsPerCell,
            indexing: this.design.indexing,
            embryoRescue: this.design.embryoRescue,
            minimumSeedsToReturn: this.design.minimumSeedsToReturn,
            samplingNeeded: this.design.requestedSamplings && this.design.requestedSamplings.length ? true : false,
            statusId: this.requestInformation.statusId,
            standardHarvest: this.design.harvestPreference.standardHarvest,
            haploidInduction: this.design.harvestPreference.haploidInduction,
            manyToOne: this.design.harvestPreference.manyToOne,
            uniquePedigree: this.design.harvestPreference.uniquePedigree,
            pollinationInstructions: pollinationInstructions,
            recurrencePattern: this.design.recurrencePattern,
            recurrenceWeekInterval: this.design.recurrenceWeekInterval,
            recurrenceDays: this.design.recurrenceDays,
            recurrenceEndDate: this.design.recurrenceEndDate,
            totalSeedsToStart: treatments ? asEnumerable(treatments).Select(function (t) { return t.plantingInstructions.seedsToStart; }).Sum() : null,
            totalPlantsToPots: treatments ? asEnumerable(treatments).Select(function (t) { return t.plantingInstructions.plantsToPots; }).Sum() : null,
            totalPlantsToHarvest: treatments ? asEnumerable(treatments).Select(function (t) { return t.plantingInstructions.plantsToHarvest; }).Sum() : null,
            requestedSamplings: samplings,
            seedNeeds: requestedSeed,
            treatments: treatments,
            seedRequestDesired: this.design.seedRequestDesired,
            originatingSystem: this.design.originatingSystem,
            pesticideInstruction: this.design.pesticideInstructionId ? this.config.pesticideInstructions.Single(function (i) { return i.id === _this.design.pesticideInstructionId; }).name : null,
            pesticidesAllowedAfterDays: this.design.pesticideInstructionId ? this.design.pesticidesAllowedAfterDays : null,
            pesticideLifeOfPlant: this.design.pesticideLifeOfPlant,
            displayPesticidesAllowedAfterDays: this.design.pesticideInstructionId ? this.config.pesticideInstructions.Single(function (i) { return i.id === _this.design.pesticideInstructionId; }).requiresNumberOfDays : false,
        };
    };
    return RequestReviewResolver;
}());
export { RequestReviewResolver };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/resolvers/request-review.resolver.ts.pre-build-optimizer.js